<template>
	<div id="mis-tickets-page">
		<div class="container">
			<div class="mis-tickets-header">
				<div class="breadcrumb">
					<router-link :to="{ name: 'home' }" class="breadcrumb-item">Inicio</router-link>
					<div class="breadcrumb-item">&#8594;</div>
					<router-link :to="{ name: 'informacion-personal' }" class="breadcrumb-item">Cuenta</router-link>
					<div class="breadcrumb-item">&#8594;</div>
					<div class="breadcrumb-item">Mis tickets</div>
				</div>
				<h1>Mis tickets</h1>
			</div>
			<clip-loader class="tickets-loader" :color="'var(--color-primary)'" :size="'52px'" v-if="isCargandoTickets"></clip-loader>
			<div class="mis-tickets-content" v-if="!isCargandoTickets && ticketsActivos.length > 0">
				<div class="mis-tickets">
					<div class="ticket" v-for="ticket in ticketsActivos" :key="ticket.TicketId">
						<span class="ticket-id">No. {{ ticket.TicketId }}</span>
						<div class="ticket-top">
							<span class="evento-nombre">{{ ticket.EventoNombre }}</span>
							<img :src="ticket.EventoFotoPrincipal" :alt="ticket.EventoNombre" class="evento-foto">
						</div>
						<div class="ticket-row">
							<div class="field-group field-group-60">
								<label>Fecha</label>
								<span class="field">{{ ticket.EventoFechaHoraEscrita }}</span>
							</div>
							<div class="field-group field-group-40">
								<label>Lugar</label>
								<span class="field">{{ ticket.EscenarioNombre }}</span>
							</div>
						</div>
						<div class="divider" v-if="ticket.EventoTicketNominado"></div>
						<div class="ticket-row" v-if="ticket.EventoTicketNominado">
							<div class="field-group field-group-100">
								<label>Espectador</label>
								<span class="field">{{ ticket.PersonaNombre }} {{ ticket.PersonaApellido }}</span>
							</div>
						</div>
						<div class="ticket-row" v-if="ticket.EventoTicketNominado">
							<div class="field-group field-group-100">
								<label>Documento</label>
								<span class="field">{{ ticket.PersonaDocumentoTipoNombre }} - {{ ticket.PersonaDocumento }}</span>
							</div>
						</div>
						<div class="ticket-bottom">
							<a :href="ticket.TicketURLS3" target="_blank" v-if="ticket.TicketGeneradoEnS3"><i class='bx bx-qr'></i>Ver ticket</a>
							<div class="ticket-generando" v-if="!ticket.TicketGeneradoEnS3">Generando ticket <clip-loader class="generando-loader" :color="'var(--color-darker)'" :size="'12px'"></clip-loader></div>
							<span class="disclaimer-generando" v-if="!ticket.TicketGeneradoEnS3">Estamos generando tu ticket. Aguarde unos segundos y podrás descargarlo.</span>
						</div>
					</div>
				</div>
			</div>
			<div class="mis-tickets-not-found"  v-if="!isCargandoTickets && ticketsActivos.length === 0">
				<span>No se encontró ningún ticket.</span>
			</div>
			<div class="mostrar-mas-container" v-if="isHayMasActivos && !isCargandoTickets">
				<div @click="mostrarMasActivos()" class="button-mostrar-mas">
					Mostrar más tickets
				</div>
			</div>
			<h3 v-if="!isCargandoTickets && ticketsAnteriores.length > 0">Eventos pasados</h3>
			<div class="mis-tickets-content" v-if="!isCargandoTickets && ticketsAnteriores.length > 0">
				<div class="mis-tickets tickets-pasados">
					<div class="ticket" v-for="ticket in ticketsAnteriores" :key="ticket.TicketId">
						<span class="ticket-id">No. {{ ticket.TicketId }}</span>
						<div class="ticket-top">
							<span class="evento-nombre">{{ ticket.EventoNombre }}</span>
							<img :src="ticket.EventoFotoPrincipal" :alt="ticket.EventoNombre" class="evento-foto">
						</div>
						<div class="ticket-row">
							<div class="field-group field-group-60">
								<label>Fecha</label>
								<span class="field">{{ ticket.EventoFechaHoraEscrita }}</span>
							</div>
							<div class="field-group field-group-40">
								<label>Lugar</label>
								<span class="field">{{ ticket.EscenarioNombre }}</span>
							</div>
						</div>
						<div class="divider" v-if="ticket.EventoTicketNominado"></div>
						<div class="ticket-row" v-if="ticket.EventoTicketNominado">
							<div class="field-group field-group-100">
								<label>Espectador</label>
								<span class="field">{{ ticket.PersonaNombre }} {{ ticket.PersonaApellido }}</span>
							</div>
						</div>
						<div class="ticket-row" v-if="ticket.EventoTicketNominado">
							<div class="field-group field-group-100">
								<label>Documento</label>
								<span class="field">{{ ticket.PersonaDocumentoTipoNombre }} - {{ ticket.PersonaDocumento }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="mostrar-mas-container" v-if="isHayMasAnteriores && !isCargandoTickets">
				<div @click="mostrarMasAnteriores()" class="button-mostrar-mas">
					Mostrar más tickets
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import { createNamespacedHelpers } from 'vuex';
	const { mapState } = createNamespacedHelpers('AuthModule');
	import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

	export default {
		data(){
			return {
				isCargandoTickets: true,
				ticketsActivos: [],
				ticketsAnteriores: [],
				iterActivos: 0,
				iterAnteriores: 0,
				isHayMasActivos: true,
				isHayMasAnteriores: true,
				cantidadIntentos: 0
			}
		},
		components: {
			ClipLoader
		},
		metaInfo: {
			title: 'Mis tickets',
			titleTemplate: '%s 🎟 LineUp Tickets'
		},
		computed: {
			...mapState({
				user: state => state.user	
			}),
			cantidadTicketsSinGenerar(){
				let cant = 0

				this.ticketsActivos.forEach((t) => {
					if(t.TicketGeneradoEnS3 === false){
						cant = cant + 1
					}
				});

				return cant
			}
		},
		async mounted(){
			await this.getTickets();
		},
		watch: {
			ticketsActivos(newticketsActivos){
				this.ticketsActivos.forEach((t, index) => {
					if(t.TicketGeneradoEnS3 === false){
						this.timeoutCheckearTicket(t.TicketId, t.TicketURLS3Bucket, index);
					}
				});
			}
		},
		methods: {
			async getTickets(){
				try {
					let response = await axios.post('/WSTicketListar', {
						UsuarioId: this.user.UsuarioId,
						IteracionActivos: this.iterActivos,
						IteracionAnteriores: this.iterAnteriores
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if(response.data.ErrorCod === 11 || response.data.ErrorCod === 10 || response.data.ErrorCod === 1){
						await this.logout();
					} else {
						if(response.data.ErrorCod === 0){
							if(response.data.SDTTicketsPasados.length < 5){
								this.isHayMasAnteriores = false
							}

							if(response.data.SDTTicketsActivos.length < 5){
								this.isHayMasActivos = false
							}
							
							this.ticketsActivos = response.data.SDTTicketsActivos;
							this.ticketsAnteriores = response.data.SDTTicketsPasados;
						}
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error al intentar obtener tus tickets.')
					this.$router.push({ name: 'error' });
				} finally {
					this.isCargandoTickets = false
				}
			},
			timeout(){
				return new Promise(resolve => setTimeout(resolve, 5000));
			},
			async timeoutCheckearTicket(ticketId, urlS3, index){
				do {
					await this.timeout();
					await this.checkearTicketGenerado(ticketId, urlS3);
				} while (this.ticketsActivos[index].TicketGeneradoEnS3 === false)
			},
			async checkearTicketGenerado(ticketId, urlS3){
				try {
					if(this.cantidadIntentos <= 5 * this.cantidadTicketsSinGenerar){
						let response = await fetch(urlS3);

						if(response.status === 200){
							let indexEmitidos = this.ticketsActivos.map(ticket => ticket.TicketId).indexOf(ticketId)
							this.ticketsActivos[indexEmitidos].TicketGeneradoEnS3 = true;

							this.cantidadIntentos = this.cantidadIntentos + 1
						} else {
							this.cantidadIntentos = this.cantidadIntentos + 1
							console.log('Ocurrió un error al checkear generación del PDF')
						}
						
						// if(response.data.ErrorCod === 0){
						// 	if(response.data.isGeneradoEnS3 === true){
						// 		let indexEmitidos = this.ticketsActivos.map(ticket => ticket.TicketId).indexOf(ticketId)
						// 		this.ticketsActivos[indexEmitidos].TicketGeneradoEnS3 = true;
						// 	}

						// 	this.cantidadIntentos = this.cantidadIntentos + 1
						// } else {
						// 	this.cantidadIntentos = this.cantidadIntentos + 1
						// 	console.log('Ocurrió un error al checkear generación del PDF')
						// }
					}
				} catch (error) {
					console.log('Ocurrió un error al checkear generacion del PDF')
				}
			},
			async mostrarMasAnteriores(){
				try {
					this.isCargandoTickets = true
					this.iterAnteriores = this.iterAnteriores + 1

					let response = await axios.post('/WSTicketListar', {
						UsuarioId: this.user.UsuarioId,
						IteracionActivos: this.iterActivos,
						IteracionAnteriores: this.iterAnteriores
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if(response.data.ErrorCod === 11 || response.data.ErrorCod === 10 || response.data.ErrorCod === 1){
						await this.logout();
					} else {
						if(response.data.ErrorCod === 0){
							if(response.data.SDTTicketsPasados.length < 5){
								this.isHayMasAnteriores = false
							}

							response.data.SDTTicketsPasados.map((t)=>{
								this.ticketsAnteriores.push(t);
							});
						}
					}
				} catch (error) {
					this.$router.push({ name: 'error' });
				} finally {
					this.isCargandoTickets = false
				}
			},
			async mostrarMasActivos(){
				try {
					this.isCargandoTickets = true
					this.iterActivos = this.iterActivos + 1

					let response = await axios.post('/WSTicketListar', {
						UsuarioId: this.user.UsuarioId,
						IteracionActivos: this.iterActivos,
						IteracionAnteriores: this.iterAnteriores
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if(response.data.ErrorCod === 11 || response.data.ErrorCod === 10 || response.data.ErrorCod === 1){
						await this.logout();
					} else {
						if(response.data.ErrorCod === 0){
							if(response.data.SDTTicketsActivos.length < 5){
								this.isHayMasActivos = false
							}

							response.data.SDTTicketsActivos.map((t)=>{
								this.ticketsActivos.push(t);
							});
						}
					}
				} catch (error) {
					this.$router.push({ name: 'error' });
				} finally {
					this.isCargandoTickets = false
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	#mis-tickets-page{
		background-color: var(--color-white);
		@include flex(column, flex-start, flex-start);
		padding: 60px 0px;

		.mis-tickets-header{
			width: 100%;
			@include flex(column, flex-start, flex-start);
			margin-bottom: 40px;

			.breadcrumb {
				@include flex(row, flex-start, center);

				.breadcrumb-item {
					font-size: 12px;
					font-weight: var(--fw-600);
					letter-spacing: 0.3px;
					font-family: var(--font-sora);
					color: var(--color-darker);
					text-transform: capitalize;
					padding: 0px 5px;

					&:first-child{
						padding: 0px 5px 0px 0px;
					}
				}
			}

			h1{
				margin: 0;
				margin-top: 12px;
				font-family: var(--font-sora);
				font-size: 30px;
				line-height: 1em;
			}
		}

		h3{
			margin-top: 30px;
			margin-bottom: 20px;
			font-weight: var(--fw-700);
			line-height: 1.4em;
		}

		.tickets-loader{
			padding: 80px 0px;
			@include flex(row, center, center);
			width: 100%;
		}

		.mis-tickets-content{
			width: 100%;
			@include flex(column, flex-start, flex-start);

			.mis-tickets{
				width: 100%;
				margin: 0px;
				display: grid;
				grid-template-columns: repeat(3, 1fr);
				grid-auto-rows: 1fr;
				grid-column-gap: 20px;
				grid-row-gap: 20px;

				&.tickets-pasados{
					.ticket{
						background-color: #f1f1f1;
					}
				}

				.ticket{
					background: var(--color-white);
					border-radius: 12px;
					padding: 20px;
					border: 1px solid rgb(221, 221, 221);
					box-shadow: rgba(0, 0, 0, 0.12) 0px 6px 16px;
					@include flex(column, flex-start, flex-start);

					.ticket-id{
						font-size: 10px;
						color: #9aa5b5;
						font-weight: var(--fw-400);
						line-height: 1.4em;
						margin-bottom: 5px;
					}

					.ticket-top{
						width: 100%;
						@include flex(row, space-between, flex-start);
						margin-bottom: 8px;

						.evento-nombre{
							width: calc(100% - 74px);
							font-size: 16px;
							font-weight: var(--fw-700);
							line-height: 1.4em;
							font-family: var(--font-sora);
						}

						.evento-foto{
							width: 54px;
							height: 54px;
							object-fit: cover;
							border-radius: 8px;
						}
					}

					.ticket-row{
						width: 100%;
						@include flex(row, space-between, center);

						.field-group{
							width: 50%;
							margin: 7px 0px;
							@include flex(column, center, flex-start);

							&.field-group-100{
								width: 100%;
							}

							&.field-group-40{
								width: 40%;
							}

							&.field-group-60{
								width: 60%;
							}

							label{
								font-size: 12px;
								font-weight: var(--fw-600);
								letter-spacing: 0.3px;
								line-height: 1.4em;
							}

							.field{
								font-size: 13px;
								line-height: 1.4em;
							}
						}
					}

					.divider{
						width: 100%;
						height: 1px;
						background-color: rgb(221, 221, 221);
						margin: 7px 0px;
					}

					.ticket-bottom{
						width: 100%;
						margin-top: 10px;
						@include flex(column, flex-end, flex-start);
						
						a{
							width: 100%;
							text-decoration: none;
							@include flex(row, center, center);
							background-color: #222222;
							border: 1px solid #222222;
							border-radius: 8px;
							outline: none;
							padding: 11px 16px;
							color: var(--color-white);
							font-size: 13px;
							font-weight: var(--fw-600);
							font-family: var(--font-sora);
							line-height: 1.4em;
							letter-spacing: 1px;
							margin: 0px;
							@include transition(all 0.2s);
							cursor: pointer;

							&:hover {
								background-color: var(--color-primary);
								border: 1px solid #222222;
								color: #222222;
								transform: translate(-0.25rem, -0.25rem);
								box-shadow: 0.25rem 0.25rem 0 #222222;
							}

							i{
								font-size: 16px;
								margin-right: 8px;
							}
						}

						.generando-loader{
							margin-left: 10px;
							margin-bottom: -3px;
						}

						.ticket-generando{
							width: 100%;
							text-decoration: none;
							@include flex(row, center, center);
							background-color: #f1f1f1;
							border: 1px solid #f1f1f1;
							border-radius: 8px;
							outline: none;
							padding: 11px 16px;
							color: var(--color-darker);
							font-size: 13px;
							font-weight: var(--fw-600);
							font-family: var(--font-sora);
							line-height: 1.4em;
							letter-spacing: 1px;
							margin: 0px;
						}

						.disclaimer-generando{
							margin-top: 8px;
							font-size: 11px;
							line-height: 1.4em;
							width: 100%;
						}
					}
				}
			}
		}

		.mis-tickets-not-found{
			width: 100%;
			@include flex(row, center, center);

			span{
				background-color: #e8e9eb;
				padding: 10px 14px;
				font-size: 12px;
				border-radius: 8px;
				line-height: 1.3em;
				margin: 20px auto;
				text-align: center;
			}
		}

		.mostrar-mas-container{
			width: 100%;
			@include flex(row, center, center);
			margin: 20px 0px;

			.button-mostrar-mas{
				border: 1px solid var(--color-darker);
				padding: 9px 12px;
				border-radius: 22px;
				font-size: 14px;
				font-weight: var(--fw-700);
				font-family: var(--font-sora);
				line-height: 1em;
				cursor: pointer;
				@include transition(all .2s);

				&:hover{
					background-color: var(--color-darker);
					color: var(--color-white);
				}
			}
		}
	}

	@media screen and(max-width: 1400px){
		#mis-tickets-page{
			padding: 30px 0px;

			.container{
				padding-left: 24px;
				padding-right: 24px;
			}

			.mis-tickets-header{
				margin-bottom: 20px;
			}
		}
	}

	@media screen and(max-width: 1270px){
		#mis-tickets-page{
			.mis-tickets-content{
				.mis-tickets{
					grid-template-columns: repeat(2, 1fr);
				}
			}
		}
	}

	@media screen and(max-width: 820px){
		#mis-tickets-page{
			.container{
				max-width: 500px;
			}

			.mis-tickets-content{
				.mis-tickets{
					grid-template-columns: repeat(1, 1fr);
				}
			}
		}
	}

	@media screen and(max-width: 620px){
		#mis-tickets-page{
			.mis-tickets-header{
				.breadcrumb {
					.breadcrumb-item {
						font-size: 11px;
					}
				}

				h1{
					margin-top: 8px;
					font-size: 22px;
				}
			}

			h3{
				margin-top: 20px;
				margin-bottom: 14px;
				font-weight: var(--fw-700);
				line-height: 1.4em;
				font-size: 18px;
			}

		}
	}
</style>